import { useCallback, useEffect, useState } from 'react';
import {
  detectInAppBrowser,
  openUrlInExternalBrowser,
  resolveSmartAppLinkMode,
  type InAppBrowser,
  type SmartAppLinkMode,
} from '../utils/inAppBrowserEscape';

type SmartAppStoreRedirectState = {
  mode: SmartAppLinkMode;
  inAppBrowser: InAppBrowser | null;
  storeUrl: string | null;
  openStore: () => void;
};

export function useSmartAppStoreRedirect(): SmartAppStoreRedirectState {
  const [mode, setMode] = useState<SmartAppLinkMode>('landing');
  const [inAppBrowser, setInAppBrowser] = useState<InAppBrowser | null>(null);
  const [storeUrl, setStoreUrl] = useState<string | null>(null);

  useEffect(() => {
    const resolved = resolveSmartAppLinkMode(navigator.userAgent);
    setInAppBrowser(resolved.inAppBrowser);
    setStoreUrl(resolved.storeUrl);
    setMode(resolved.mode);
  }, []);

  const openStore = useCallback(() => {
    if (!storeUrl) return;
    const app = inAppBrowser ?? detectInAppBrowser();
    if (app) {
      openUrlInExternalBrowser(app, storeUrl);
      return;
    }
    window.location.href = storeUrl;
  }, [inAppBrowser, storeUrl]);

  return { mode, inAppBrowser, storeUrl, openStore };
}
